import { SettingsGeneralV2 } from "@/components/settings-v2/general"
import { useLanguage } from "@/context/language"
import { SettingsReturnLink } from "@/components/settings-return-link"

export function CoworkSettingsPage() {
  const language = useLanguage()

  return (
    <div class="min-h-full bg-v2-background-bg-deep px-4 py-7 sm:px-7 xl:px-10">
      <div class="mx-auto max-w-[1100px]">
        <SettingsReturnLink always />
        <header>
          <h1 class="text-[30px] font-semibold tracking-[-0.025em] text-v2-text-text-base">
            {language.t("cowork.enterprise.settings.general")}
          </h1>
          <p class="mt-1 text-[13px] text-v2-text-text-muted">
            {language.t("cowork.enterprise.settings.generalDescription")}
          </p>
        </header>
        <section class="application-settings-page mt-7">
          <SettingsGeneralV2 hideHeader />
        </section>
      </div>
    </div>
  )
}
